// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Commands
// MODIFIED DATE : 07-08-2025

/* eslint-disable import/no-anonymous-default-export */
import CenterWiseLoanProposalActionTypes from './center-wise-loan-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// Add loan proposal Response
	addCenterWiseLoanPropsalResponse: null,

	// Update proposal response
	updateCenterWiseLoanProposalResponse: null,

	// Get Center Wise Loan Proposal Resposne
	getCenterWiseLoanProposalResponse: null,

	// Get Cneter Wise Loan Proposal Array
	getCenterWiseLoanProposalListArr: [],

	// Approve Center Wise Loan Proposal Resposne
	approveCenterWiseLoanPropsalResponse: null,

	// Delete Center Wise Loan Proposal Response
	deleteCenterWiseLoanPropsalResponse: null,

	// Fetch Mmeber List Cneter Wise Loan Resposne
	fetchMembersListForCenterWiseLoanResponse: null,

	// Fetch Mmeber List Cneter Wise Loan Array
	fetchMembersListForCenterWiseLoanArr: [],

	// Fetch Center Wise Loan Proposal Resposne
	fetchCenterWiseLoanPropsalResponse: null,

	// Fetch Center Wise Loan Proposal Array
	fetchCenterWiseLoanProposalArr: [],

	// Add Member Bank Details Resposne
	addMemberBankDetailsResponse: null,

	// Fetch Member Bank Details Resposne
	fetchMemberBankDetailsResponse: null,

	// Fetch Member Bank Details Array
	fetchMemberBankDetailsArr: [],

	// Update Correct Loan Start/End Date For Member Response
	updateCorrectLoanStartEndDateForMemberResponse: null,

	// Update Correct Loan For Overall Member Response
	updateCorrectLoanForOverallMemberResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START ADD CENTER WISE LOAN PROPOSAL  ******************** */
		case CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_SUCCESS:
			return { ...state, addCenterWiseLoanPropsalResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_FAILURE:
			return { ...state, addCenterWiseLoanPropsalResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addCenterWiseLoanPropsalResponse: null };
		/** *********************  END ADD CENTER WISE LOAN PROPOSAL  ******************** */

		/** *********************  START UPDATE CENTER WISE LOAN PROPOSAL  ******************** */
		case CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_SUCCESS:
			return { ...state, updateCenterWiseLoanProposalResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateCenterWiseLoanProposalResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateCenterWiseLoanProposalResponse: null };
		/** *********************  END UPDATE CENTER WISE LOAN PROPOSAL  ******************** */

		/*************** START FETCH MEMBER LIST FOR CENTER WISE LOAN PROPOSAL ***************/
		case CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_SUCCESS:
			return {
				...state,
				fetchMembersListForCenterWiseLoanResponse: action.payload,
				fetchMembersListForCenterWiseLoanArr: docodeHexResponse(
					action.payload,
					'GetCenterWiseMembersListKey',
				),
			};

		case CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_FAILURE:
			return { ...state, fetchMembersListForCenterWiseLoanResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_RESPONSE_CHANGED:
			return {
				...state,
				fetchMembersListForCenterWiseLoanResponse: null,
			};
		/*************** END FETCH MEMBER LIST FOR CENTER WISE LOAN PROPOSAL ***************/

		/*************** START FETCH CENTER WISE LOAN PROPOSAL ***************/
		case CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				fetchCenterWiseLoanPropsalResponse: action.payload,
				fetchCenterWiseLoanProposalArr: docodeHexResponse(
					action.payload,
					'getParticularBranchLoanIndexInfoKey',
				),
			};

		case CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_FAILURE:
			return { ...state, fetchCenterWiseLoanPropsalResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return {
				...state,
				fetchCenterWiseLoanPropsalResponse: null,
				fetchCenterWiseLoanProposalArr: [],
			};
		/*************** END FETCH CENTER WISE LOAN PROPOSAL ***************/

		/** *********************  START ADD MEMBER BANK DETAILS  ******************** */
		case CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_SUCCESS:
			return { ...state, addMemberBankDetailsResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_FAILURE:
			return { ...state, addMemberBankDetailsResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_RESPONSE_CHANGED:
			return { ...state, addMemberBankDetailsResponse: null };
		/** *********************  END ADD MEMBER BANK DETAILS  ******************** */

		/** *********************  START FETCH MEMBER BANK DETAILS  ******************** */
		case CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_SUCCESS:
			return {
				...state,
				fetchMemberBankDetailsResponse: action.payload,
				fetchMemberBankDetailsArr: docodeHexResponse(
					action.payload,
					'MemberBankDetailsKey',
				),
			};

		case CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_FAILURE:
			return { ...state, fetchMemberBankDetailsResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchMemberBankDetailsResponse: null };
		/** *********************  END FETCH MEMBER BANK DETAILS  ******************** */

		/** *********************  START UPDATE CORRECT LOAN START/END DATE FOR MEMBER  ******************** */
		case CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_SUCCESS:
			return { ...state, updateCorrectLoanStartEndDateForMemberResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_FAILURE:
			return { ...state, updateCorrectLoanStartEndDateForMemberResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_RESET:
			return { ...state, updateCorrectLoanStartEndDateForMemberResponse: null };
		/** *********************  END UPDATE CORRECT LOAN START/END DATE FOR MEMBER  ******************** */

		/** *********************  START UPDATE CORRECT LOAN FOR OVERALL MEMBER  ******************** */
		case CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_SUCCESS:
			return { ...state, updateCorrectLoanForOverallMemberResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_FAILURE:
			return { ...state, updateCorrectLoanForOverallMemberResponse: action.payload };

		case CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_RESET:
			return { ...state, updateCorrectLoanForOverallMemberResponse: null };
		/** *********************  END UPDATE CORRECT LOAN FOR OVERALL MEMBER  ******************** */

		default:
			return state;
	}
};
